<template>
    <div>
        <button class="btn btn-outline-dark" @click="showUser = !showUser">Create Users</button>
        <br />
        <div v-if="showUser">
            <div v-if="!parse">
                <b-form-group
                    class="mt-3"
                    description="Only .csv file accepted"
                    label="Select file"
                >
                    <b-form-file
                        v-model="file"
                        placeholder="Choose file or drop it here..."
                        drop-placeholder="Drop file here..."
                        accept=".csv"
                    ></b-form-file>
                </b-form-group>
                <button class="btn btn-sm btn-outline-success" @click="parseFile()">Parse</button>
            </div>
            <div v-else>
                <br />
                <table class="table">
                    <thead>
                        <tr>
                            <th>Email</th>
                            <th>Display Name</th>
                            <th>Type</th>
                            <th>Parent Email</th>
                            <th>School</th>
                            <th>Phone</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in userData" v-bind:key="user.email">
                            <td>{{ user.email }}</td>
                            <td>{{ user.name }}</td>
                            <td>{{ user.type }}</td>
                            <td>{{ user.parentEmail }}</td>
                            <td>{{ user.school }}</td>
                            <td>{{ user.phone }}</td>
                        </tr>
                    </tbody>
                </table>
                <button class="btn btn-sm btn-outline-success" @click="submitUser()">Create</button>
            </div>
        </div>
    </div>
</template>

<script>
const fb = require("../../firebaseConfig");
const papa = require("papaparse");
const createUser = fb.functions.httpsCallable("createUser");

export default {
    data() {
        return {
            showUser: false,
            parse: false,
            file: null,
            userData: []
        };
    },
    methods: {
        parseFile() {
            if (!this.file) {
                this.makeToast("err", "Select a file");
                return;
            }
            papa.parse(this.file, {
                header: true,
                skipEmptyLines: true,
                complete: results => {
                    this.userData = results.data;
                }
            });
            this.parse = true;
        },
        submitUser() {
            createUser({ userList: this.userData }).then(res => {
                console.log(res.data);
                this.$emit('toast', 'war', 'Process complete. Check logs in developer console.')
            });
            this.userData = [];
            this.file = null;
            this.parse = false;
            this.showUser = false;
        }
    }
};
</script>